export default "__VITE_ASSET__b260c7b0__"